import { Button } from '@components/ui/button'
import { MirrorCopyIcon, MirrorMoveIcon } from '@components/ui/custom-icons'
import type { MirrorAvailability } from '../helpers/mirror-availability'

interface MirrorButtonsProps {
  availability: MirrorAvailability
  onMirrorMove: () => void
  onMirrorCopy: () => void
  /** Drives the canvas ghost preview; only reports `true` while the hovered button is enabled. */
  onHoverChange?: (hovering: boolean) => void
}

export function MirrorButtons({
  availability,
  onMirrorMove,
  onMirrorCopy,
  onHoverChange,
}: MirrorButtonsProps) {
  const buttons = [
    {
      key: 'move',
      eligible: availability.mirrorMoveEligible,
      onClick: onMirrorMove,
      title: availability.mirrorMoveTooltip,
      Icon: MirrorMoveIcon,
    },
    {
      key: 'copy',
      eligible: availability.mirrorCopyEligible,
      onClick: onMirrorCopy,
      title: availability.mirrorCopyTooltip,
      Icon: MirrorCopyIcon,
    },
  ]

  return (
    <div className="space-y-2 pb-4">
      <label className="text-sm font-medium text-foreground leading-none">Mirror</label>
      <div className="flex gap-2 mt-2">
        {buttons.map(({ key, eligible, onClick, title, Icon }) => (
          <Button
            key={key}
            variant="outline"
            size="icon"
            className="text-muted-foreground"
            disabled={!eligible}
            onClick={onClick}
            onMouseEnter={() => eligible && onHoverChange?.(true)}
            onMouseLeave={() => onHoverChange?.(false)}
            onFocus={() => eligible && onHoverChange?.(true)}
            onBlur={() => onHoverChange?.(false)}
            title={title}
          >
            <Icon className="h-4 w-4" />
          </Button>
        ))}
      </div>
    </div>
  )
}
